import { render, staticRenderFns } from "./ResponsiveComponent.vue?vue&type=template&id=3baa2572"
import script from "./ResponsiveComponent.vue?vue&type=script&lang=js"
export * from "./ResponsiveComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports